

































import UploadHeader from './UploadHeader.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { enCvParseApi } from '@/api/student-management';
import { FileAnalysisModule } from '@/store/modules/file_analysis';
import { AppModule } from '@/store/modules/app';

@Component({
  components: {
    UploadHeader
  }
})
export default class extends Vue {
  @Prop({ required: true }) public contentInfo!: any;
  @Prop({ default: true }) public isNotUpload!: boolean;
  @Prop() public type!: string;

  public personInfo = {};
  public warnList: any = {
    '-9101':'stuManagement.aiCode1',// 证件边框不完整告警
    '-9102':'stuManagement.aiCode2',// 证件复印件告警
    '-9103':'stuManagement.aiCode3',// 证件翻拍告警
    '-9104':'stuManagement.aiCode4',// 证件PS告警
    '-9107':'stuManagement.aiCode5',// 证件反光告警
    '-9108':'stuManagement.aiCode6',// 证件模糊告警
    '-9109':'stuManagement.aiCode7',// 告警能力未开通
  }

  public fileTypes: string[] = [
    'image/jpeg', 'image/png', 'application/pdf', 'image/bmp', 'image/gif', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'
  ];

  get language() {
    return AppModule.language;
  }

  public getImageUrl(lan: string) {
    try {
      return require(`@/assets/image/common/passport_${lan}.png`);
    } catch(err) {
      return '';
    }
  }

  public beforeUpload(file: any) {
    if (!this.fileTypes.includes(file.type)) {
      this.$message.error(this.$t('common.fileUploadTips') as string);
      return false;
    } else if (file.size / 1024 / 1024 > 5) {
      this.$message.error(this.$t('common.fileUploadTips2', { size: 5 }) as string);
      return false;
    }
    return true;
  }

  public uploadSuccess() {
    // this.$emit('upload-file', this.type)
  }
  // 上传
  public async fileUpload(params: any) {
    const file = params.file;
    const type = this.type;
    const formData =  new FormData();
    formData.append('file', file);
    formData.append('type', type);
    formData.append(' businessFileType', 'PASSPORT');
    try {
      const { data } = await enCvParseApi(formData);
      const resData = JSON.parse(data.data);
      if (resData.data.error_code) {
        return this.$message.error(resData.data.error_msg);
      }
      if (resData.status === 'success') {
        const passportData = resData.data;
        let warnFlag: any = false;
        let length: number = 20
        // 如果有有警告则不上传
        if (passportData.Warn && passportData.Warn.length&&
          ((!passportData.Name && !this.getFormatDate(passportData.BirthDate)) ||// 内地护照
          !passportData.zhSurname && !passportData.zhGivenName && !this.getFormatDate(passportData.DateOfBirth)// 其他护照
          )
        ) {
          for(const item of passportData.Warn) {
            if (this.warnList[item]) {
              this.$message(
                {
                  type:'error',
                  message:this.$t(this.warnList[item]) as any,
                  offset:length += 35
                }
              );
              warnFlag=true;
            }
          }
        }
        if (warnFlag) {
          return
        }
        const guid = resData.fkGuIds[0];
        const gender = passportData.Sex?['女/F', '女', 'F'].includes(passportData.Sex) ? 0 : 1:'';
        if (type === 'issueFileResolverPassportCn') {// 内地护照
          const personInfo = {
            fkGuidAndType: { [guid]: 'PASSPORT' },
            nameZh: passportData.Name,
            birthday: this.getFormatDate(passportData.BirthDate),
            gender, // 1:男 0:女
            lastName: passportData.FamilyName,
            firstName: passportData.FirstName,
            passportNumber: passportData.PassportNo,
            passportIssueDate: this.getFormatDate(passportData.IssueDate),
            passportIssueExpried: this.getFormatDate(passportData.ExpiryDate),
            fkStudentAppCountryIdFrom: 44,
            fkStudentAppCountryIdPassport: 44,
            isHavePassport: true,
            title: gender === 0 ? 2 : 1,
            cityBirth: passportData.BirthPlace,
          }
          this.personInfo = personInfo;
          console.log(personInfo);
          this.$emit('set-analysis-status', {type: this.type, personInfo});
          FileAnalysisModule.SET_PERSON_INFO(personInfo);
        } else if (type === 'issueFileResolverPassportNational') {// 其他护照
          const personInfo = {
            fkGuidAndType: { [guid]: 'PASSPORT' },
            nameZh: `${passportData.zhSurname}${passportData.zhGivenName}`,
            birthday: this.getFormatDate(passportData.DateOfBirth),
            gender, // 1:男 0:女
            lastName: passportData.Surname,
            firstName: passportData.GivenName,
            passportNumber: passportData.ID,
            passportIssueDate: this.getFormatDate(passportData.DateOfIssuance),
            passportIssueExpried: this.getFormatDate(passportData.DateOfExpiration),
            fkStudentAppCountryIdFrom: passportData.CountryId,
            fkStudentAppCountryIdPassport: passportData.CountryId,
            isHavePassport: true,
            title: gender === 0 ? 2 : 1,
            cityBirth: passportData.BirthPlace,
          }
          this.personInfo = personInfo;
          console.log(personInfo);
          this.$emit('set-analysis-status', {type: this.type, personInfo});
          FileAnalysisModule.SET_PERSON_INFO(personInfo);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  public setEducationBackground(educationBackground: any) {
    if (educationBackground) {
      const eduBack = educationBackground.map((eduData: any, index: number) => {
        const fkAreaCityId = eduData.location.cityId;
        const fkAreaStateId = eduData.location.stateId;
        const fkStudentAppCountryId = eduData.location.countryId;
        const key = Date.now() + index;
        return {
          major: eduData.major.text,
          studyInEnglish: eduData.isEnglish ? 2 : 0,
          studyStartDate: eduData.startTime.date,
          studyEndDate: eduData.endTime.date,
          fkStudentAppCountryId: fkStudentAppCountryId === -1 ? '' : fkStudentAppCountryId,
          fkAreaStateId: fkAreaStateId === -1 ? '' : fkAreaStateId,
          fkAreaCityId: fkAreaCityId === -1 ? '' : fkAreaCityId,
          fkInstitutionIdName: eduData.institution.text,
          uniqueKey: key
        }
      });
      return eduBack;
    }
    return [];
  }

  public setWorkingExperience(workingExperience: any): any {
    if (workingExperience.length) {
      const workExp = workingExperience.map((workData: any, index: number) => {
        const companyName = workData.company.text;
        const position = workData.position.text;
        const workStartDate = workData.startTime.date;
        const workEndDate = workData.endTime.date;
        const jobDescription = workData.workScope.text;
        const workMode = workData.workingType;
        const isOnDuty = workData.isContinueJob;
        const fkStudentAppCountryId = workData.location.countryId;
        const fkAreaStateId = workData.location.stateId;
        const fkAreaCityId = workData.location.cityId;
        const key = Date.now() + index;
        return {
          companyName,
          position,
          workStartDate,
          workEndDate,
          jobDescription,
          fkStudentAppCountryId: fkStudentAppCountryId === -1 ? '' : fkStudentAppCountryId,
          fkAreaStateId: fkAreaStateId === -1 ? '' : fkAreaStateId,
          fkAreaCityId: fkAreaCityId === -1 ? '' : fkAreaCityId,
          workMode: workMode === 'part_time' ? 0 : 1, // 0: full time, 1: part time
          isOnDuty,
          uniqueKey: key
        }
      });
      return workExp;
    }
    return [];
  }

  public getFormatDate(date: string) {
    if (date && date.length === 8) {
      const year = date.substring(0, 4); // year only (YYYY) 	YYYY-YYYY 	YYYY-YY
      const month = date.substring(4, 6); // month only (MM)	MM-MM 	MM-MMM 	MMMM-
      const day = date.substring(6, 8); // day only (DD)	DD-DD 	DD-DDD 	DDDD-
      return `${year}-${month}-${day}`;
    }
    return undefined;
  }
}
